import React, {useState} from "react";
import {Row, Col, Button} from "react-bootstrap";
import BizLocationService from "../../bizLocation/BizLocationService";

import {InputWithLabel} from "../../component/Form/InputWithLabel";
import Icon from "../../component/Icon/Icon";
import Notify from "../../services/Notify";
import ModalMessageNew from "../../component/Modal/ModalMessageNew";

class GridBizLocations {

  constructor() {
    this.bizLocationsService = new BizLocationService()
  }

  customFilters = {}

  title = "Lista de Locais";

  exportNewPage = true;
  showPdfButton = false;

  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName",
      HeaderColumn: true
    },
    {
      Header: "Código ERP",
      accessor: "erpCode"
    },
    {
      Header: "Nome local do pai",
      accessor: "parent.friendlyName"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => {
        const [showModal, setShowModal] = useState(false)
        const handleShowModal = () => setShowModal(!showModal)

        const handleDeleteBizLocationById = async (bizLocationId) => {
          try {
            await this.bizLocationsService.deleteById(bizLocationId)
            this.forceReload()
            Notify.success("Local deletado com sucesso!")
          } catch (error) {
            Notify.error("Houve um erro ao deletar o local, por favor tente novamente mais tarde.", error)
          } finally {
            setShowModal(false)
          }
        }
        return (
          <Row className="justify-content-around">
            <Col sm={4}>
              <Button title="Níveis de estoque" bsStyle="info"
                      href={`#/list/stock-levels/${row.original.id}`} block>
                <Icon icon="bar-chart"/>
              </Button>
            </Col>
            <Col sm={4}>
              <Button title="Editar" bsStyle="success"
                      href={"#/biz-locations/" + row.original.id + "/edit"} block>
                <Icon icon="pencil"/>
              </Button>
            </Col>
            <Col sm={4}>
              <Button onClick={handleShowModal} title="Excluir" bsStyle="danger" block>
                <Icon icon="trash"/>
              </Button>
            </Col>
            <ModalMessageNew
              title={`Tem certeza que deseja deletar o local ${row.original.friendlyName} ?`}
              showModal={showModal}
              handleShowModal={handleShowModal}
              errorButtonAction={handleShowModal}
              successButtonAction={() => handleDeleteBizLocationById(row.original.id)}
            />
          </Row>

        )
      }
    }
  ];

  customFilterComponent = (props, state, onChange) => {
    return (
      <Row>
        <Col md={6}>
          <InputWithLabel label="Nome" placeholder="Digite o nome" onChangeWithDelay={e => {
            this.customFilters.friendlyName = e
            onChange(this.customFilters)
          }}/>
        </Col>
        <Col md={6}>
          <InputWithLabel label="Código ERP" placeholder="Digite o código ERP" onChangeWithDelay={e => {
            this.customFilters.erpCode = e
            onChange(this.customFilters)
          }}/>
        </Col>
      </Row>
    )
  }

  endpoint = () => {
    const {friendlyName, erpCode} = this.customFilters
    const params = new URLSearchParams({})

    friendlyName && params.append('friendlyName', friendlyName)
    erpCode && params.append('erpCode', erpCode)

    return `ton/v1/biz-locations?${params.toString()}`;
  }
}

export default GridBizLocations;



// WEBPACK FOOTER //
// ./src/customGrid/entities/BizLocations.js